const showGotop = () => {
    const target = document.querySelector('.js_goTop');
    if (!target) return;
    
	const offset = 300; //TOPから何px地点で発火するか
    
    window.addEventListener('scroll', () => {
        if (window.scrollY > offset) {
            target.classList.add('is_show');
        } else {
            target.classList.remove('is_show');
        }
    });
}

export default showGotop;

